module.exports = __webpack_public_path__ + "static/personal_text.a06d4a56.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/personal_text.png
// module id = 713
// module chunks = 154382131621592